function freeProduct(freeProductId = 50241161658689) {
  console.log("Checking cart for free product...");

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let totalItems = cart.items.filter((item) => item.id !== freeProductId).reduce((sum, item) => sum + item.quantity, 0);

      let freeProductItem = cart.items.find((item) => item.id === freeProductId);
      let hasFreeProduct = !!freeProductItem;

      console.log("Total items (excluding freebie):", totalItems, "Has Free Product:", hasFreeProduct);

      if (totalItems >= 6 && !hasFreeProduct) {
        console.log("Adding free product...");

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: freeProductId, quantity: 1 }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Free product added:", data);
            theme.miniCart.generateCart(); // Update mini cart UI
          })
          .catch((error) => console.error("Error adding free product:", error));

      } else if (totalItems < 6 && hasFreeProduct) {
        console.log("Removing free product...");

        if (freeProductItem) {
          fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: freeProductItem.key, quantity: 0 }),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("Free product removed:", data);
              theme.miniCart.generateCart(); // Update mini cart UI
            })
            .catch((error) => console.error("Error removing free product:", error));
        }
      }
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

document.addEventListener("DOMContentLoaded", function(){
   setTimeout(freeProduct, 500);
});

document.addEventListener("cart:updated", function(cart){
  //console.log(cart.detail)
  setTimeout(freeProduct, 500);
});
